// Import style component
import styled from 'styled-components'

import GameDetail from '../../common/GameDetail'

// Import themes modules
import { px2Rem } from '../../../themes/Mixins'

export const GameItem = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;

  @media (min-width: 768px) {
    width: ${props => props.dataLength > 6 ? '25%' : '33.33%'};

    &:hover ${GameDetail} {
      display: block;
      animation-name: gameInfo;
      animation-duration: 0.5s;

      @keyframes gameInfo {
        from {padding-top: ${px2Rem(80)};}
        to {padding-top: ${px2Rem(40)};}
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/sections/games/GamesResponsive.js